import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CaseProvider } from './contexts/CaseContext';
import { Sidebar } from './components/Sidebar';
import { LogoutModal } from './components/LogoutModal';
import { DashboardPage } from './pages/DashboardPage';
import { ReportsPage } from './pages/ReportsPage';
import { ProfilePage } from './pages/ProfilePage';
import { SettingsPage } from './pages/SettingsPage';
export function App() {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const handleLogout = () => {
    sessionStorage.clear();
    console.log('User logged out');
    setShowLogoutModal(false);
  };
  return <BrowserRouter data-id="element-0">
      <CaseProvider data-id="element-1">
        <div className="min-h-screen bg-background text-text-primary font-sans selection:bg-info/30" data-id="element-2">
          <Sidebar onLogoutClick={() => setShowLogoutModal(true)} data-id="element-3" />

          <div className="ml-20" data-id="element-4">
            <Routes data-id="element-5">
              <Route path="/" element={<DashboardPage data-id="element-7" />} data-id="element-6" />
              <Route path="/reports" element={<ReportsPage data-id="element-9" />} data-id="element-8" />
              <Route path="/profile" element={<ProfilePage data-id="element-11" />} data-id="element-10" />
              <Route path="/settings" element={<SettingsPage data-id="element-13" />} data-id="element-12" />
              <Route path="*" element={<Navigate to="/" replace data-id="element-15" />} data-id="element-14" />
            </Routes>
          </div>

          {showLogoutModal && <LogoutModal onConfirm={handleLogout} onCancel={() => setShowLogoutModal(false)} data-id="element-16" />}
        </div>
      </CaseProvider>
    </BrowserRouter>;
}